import { Svg } from '../../../hybrid/wrappers';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './Loader.module.scss';
import { generateCompStylers } from '../../../common/utils/styles';

const Loader = ({ compStyles = {}, type = 'panel' }) => {
    const { stylers, classes } = generateCompStylers(compStyles);
    return (
        <div
            style={stylers?.loader || {}}
            className={classNames(css?.mainBlock, type === 'panel' ? css?.mainBlockPanel : '', classes?.loader)}
        >
            <div className={css.loaderWrapper}>
                <div className={classNames(css.loaderIndex, css.index || '')}>
                    <span />
                </div>
                <Svg>
                    <filter id='goo'>
                        <feGaussianBlur in='SourceGraphic' stdDeviation='11' result='blur' />
                        <feColorMatrix
                            in='blur'
                            values='1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9'
                            result='goo'
                        ></feColorMatrix>
                    </filter>
                </Svg>
            </div>
        </div>
    );
};
Loader.propTypes = {
    styles: PropTypes.object,
    compStyles: PropTypes.object,
    type: PropTypes.oneOf(['panel'])
};

export default Loader;
